/**
 * Build-time public env for client bundles. Values come from Next inlining
 * `process.env.NEXT_PUBLIC_*`; invalid/missing values fail the build.
 */
function readNextPublicApiUrl(): string {
  const raw = process.env["NEXT_PUBLIC_API_URL"];
  if (raw === undefined || raw === "" || raw === "undefined") {
    throw new Error(
      "[env] NEXT_PUBLIC_API_URL is missing or invalid. Set it in .env.local (see .env.example).",
    );
  }
  return raw;
}

export const NEXT_PUBLIC_API_URL = readNextPublicApiUrl();

function isLoopbackHostname(host: string): boolean {
  const h = host.toLowerCase();
  return (
    h === "localhost" ||
    h === "127.0.0.1" ||
    h === "[::1]" ||
    h === "::1" ||
    h.startsWith("127.")
  );
}

/**
 * Resolved API prefix for browser fetches:
 * - `next dev`: empty string → call same-origin `/api/...`; `next.config.mjs` rewrites to MOT API (avoids
 *   mixed content with `--experimental-https` on LAN).
 * - Production: `NEXT_PUBLIC_API_URL` origin with LAN-loopback substitution when helpful.
 */
export function browserApiBaseUrl(): string {
  const base = NEXT_PUBLIC_API_URL.replace(/\/+$/, "");
  if (typeof window === "undefined") {
    return base;
  }
  if (process.env.NODE_ENV === "development") {
    return "";
  }

  try {
    const u = new URL(base);
    if (!isLoopbackHostname(u.hostname) || isLoopbackHostname(window.location.hostname)) {
      return base;
    }
    u.hostname = window.location.hostname;
    return u.origin;
  } catch {
    return base;
  }
}
